import { SET_LANG } from './../const';

function action(token, context, lang) {
  return { type: SET_LANG, token, context, lang };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/commons/setLang.js